import React, { Fragment } from 'react'

import { GoogleMap } from 'components'
import s from './DeliveryTimeModal.module.css'

const DeliveryTimeModal = ({ lat, long, name, address, delivery_hours }) => {
  return (
    <>
      <GoogleMap
        center={{
          lat: lat,
          lng: long
        }}
        text={name}
      />

      <div className={s.modalTimeWrapper}>
        <h2 className={s.modalTitle}>Location and Hours</h2>
        <p className={s.modalAddress}>{address} </p>
        {delivery_hours.map((item, index) => (
          <Fragment key={`d-${index}`}>
            <div className={s.day}>{item.Day}</div>
            <div className={s.modalTime}>
              {item.Time[0].StartTime}-{item.Time[0].EndTime}
            </div>
          </Fragment>
        ))}
      </div>
    </>
  )
}

export default DeliveryTimeModal
